import Vue from 'vue'
import router from './router';
import BeansAdminPlugin from 'beans-admin-plugin';
import config from './admin-plugin-config';
import './theme.scss';
import './global.scss';
import { i18n } from './i18n';

Vue.config.productionTip = false;

Vue.use(BeansAdminPlugin, config);

const app = new Vue({
  router,
  i18n,
  template: '<router-view />'
}).$mount('#app')

export default app;
